import { render, staticRenderFns } from "./WorkflowWithdraw.vue?vue&type=template&id=faf00a90&scoped=true"
import script from "./WorkflowWithdraw.vue?vue&type=script&lang=js"
export * from "./WorkflowWithdraw.vue?vue&type=script&lang=js"
import style0 from "./WorkflowWithdraw.vue?vue&type=style&index=0&id=faf00a90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf00a90",
  null
  
)

export default component.exports